import { render, staticRenderFns } from "./NorthamptonCity.vue?vue&type=template&id=c978a6b2&scoped=true&"
import script from "./NorthamptonCity.vue?vue&type=script&lang=js&"
export * from "./NorthamptonCity.vue?vue&type=script&lang=js&"
import style0 from "./NorthamptonCity.vue?vue&type=style&index=0&id=c978a6b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c978a6b2",
  null
  
)

export default component.exports